module.exports = __webpack_public_path__ + "static/img/chatbot.08fbf9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent-ai/chatbot.png
// module id = UNOC
// module chunks = 20